<h1 mat-dialog-title>Delete</h1>
<div mat-dialog-content>
    <p>Are you sure want to delete this record?</p>
</div>
<div mat-dialog-actions>
    <button mat-button style="background: #1e88e5;color: white;" [mat-dialog-close]="data.id">Delete</button>
    <button mat-button (click)="cancel()">Cancel</button>
    
</div>